__turbopack_context__.v({
  "bonus": "price-breakdown-row-module-scss-module__xvPuIW__bonus",
  "placeholder": "price-breakdown-row-module-scss-module__xvPuIW__placeholder",
  "row": "price-breakdown-row-module-scss-module__xvPuIW__row",
  "text": "price-breakdown-row-module-scss-module__xvPuIW__text",
});
